
import { Button, Form, Input, Modal, Popover, Select } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formItemLayout } from '../utils/antUtils';
import { cancelNewsletterTemplateEdit, deleteNewsletterTemplate, templateNewsletterEditAttr, saveNewsletterTemplate } from './templateActions';

const FormItem = Form.Item;
const { TextArea } = Input;
const Option = Select.Option;

class NewsletterTemplateModalComponent extends Component {

  state = {
    confirmDeleteVisible: false
  }

  handleSubmit = (e) => {

    this.props.form.validateFields((errors) => {
      if (errors) {
        return false;
      }

      this.props.dispatch(saveNewsletterTemplate(this.props.edit))
    });
  }

  handleCancel = (e) => {
    this.setState({ confirmDeleteVisible: false });
    this.props.dispatch(cancelNewsletterTemplateEdit());
  }

  deleteConfirmed = () => {
    this.setState({ confirmDeleteVisible: false });
    this.props.dispatch(deleteNewsletterTemplate(this.props.edit.id));
  }

  onChange(event, attr) {
    this.props.dispatch(templateNewsletterEditAttr(attr, event.target.value));
  }

  onChangeValue(value, attr) {
    this.props.dispatch(templateNewsletterEditAttr(attr, value));
  }

  render() {

    if (!this.props.edit) {
      return null;
    }

    const { getFieldDecorator } = this.props.form;

    let confirmPopup = (<div>
      <Button onClick={this.deleteConfirmed}>Ja</Button>
      <Button style={{ marginLeft: 10 }} onClick={() => this.setState({ confirmDeleteVisible: false })}>Nej</Button>
    </div>);

    let footer = this.props.edit.id === -1 ? [] : [<div style={{ float: 'left' }}>
      <Popover visible={this.state.confirmDeleteVisible} placement="topLeft" title={'Är du säker?'} content={confirmPopup} trigger="click">
        <Button type="danger" onClick={() => this.setState({ confirmDeleteVisible: true })} >Radera mall</Button>
      </Popover>
    </div>];

    footer.push(<Button key="back" onClick={this.handleCancel}>Avbryt</Button>);
    footer.push(<Button key="submit" type="primary" onClick={this.handleSubmit}>Spara</Button>);

    return (

      <Modal
        maskClosable={false}
        width={1400}
        maskClosable={false}
        title={this.props.edit && this.props.edit.id === -1 ?
          'Ny nyhetsbrevmall' : 'Ändra nyhetsbrevmall'}
        visible={!!this.props.edit}
        onCancel={this.handleCancel}
        footer={footer}
      >
        <div>
          <Form onSubmit={this.handleSubmit}>
            <FormItem {...formItemLayout} label="Mallnamn" >
              {getFieldDecorator('title', { rules: [{ required: true, message: 'Ange ett namn' }], })(
                <Input autoFocus onBlur={(e) => this.onChange(e, 'title')} />)}
            </FormItem>
            <FormItem {...formItemLayout} label="Databaser" >
              {getFieldDecorator('dbType', { rules: [{ required: true, message: 'Ange en eller flera databaser' }], })(
                <Input autoFocus onBlur={(e) => this.onChange(e, 'dbType')} />)}
            </FormItem>
            <FormItem >
              Sidhuvud:
              {getFieldDecorator('header')(<TextArea rows={10} onBlur={(e) => this.onChange(e, 'header')} />)}
            </FormItem>
            <FormItem >
              Sidfot:
              {getFieldDecorator('footer')(<TextArea rows={10} onBlur={(e) => this.onChange(e, 'footer')} />)}
            </FormItem>
          </Form>

        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    edit: state.templates.templateNewsletterEdit

    
    
  }
};


export default connect(mapStateToProps)(Form.create({
  mapPropsToFields(props) {
    return {
      title: Form.createFormField({ value: props.edit ? props.edit.title : '' }),
      dbType: Form.createFormField({ value: props.edit ? props.edit.dbType : '' }),
      header: Form.createFormField({ value: props.edit ? props.edit.header : '' }),
      footer: Form.createFormField({ value: props.edit ? props.edit.footer : '' })      
    }
  }
})(NewsletterTemplateModalComponent));



// WEBPACK FOOTER //
// ./src/templates/newsletterTemplateModalComponent.js